import { isPercentage } from "src/utils/utils";

const Logo = ({ width = 120, height, color }) => {
  let renderHeight = height;
  let isWidthPercentage = isPercentage(width);
  if (!isWidthPercentage) {
    if (!renderHeight) {
      renderHeight = width / (150 / 44);
    } else if (!width || !height) {
      renderHeight = 44;
    }
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 310 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.6041 2.14258H32.0039V29.0002H38.6041V2.14258Z"
        fill={color || "white"}
      />
      <path
        d="M21.8435 9.24854V28.9999H15.1909V15.8846H0V9.24854H21.8435Z"
        fill={color || "white"}
      />
      <path
        d="M32.0583 9.24854H21.8438V15.8323H32.0583V9.24854Z"
        fill={color || "white"}
      />
      <path d="M21.7916 0H15.1914V5.6955H21.7916V0Z" fill={color || "white"} />
      <path d="M10.9479 0H4.34766V5.6955H10.9479V0Z" fill={color || "white"} />
      <path
        d="M68.2549 2.14258V29.0002H44.8398V2.14258H51.44V22.4165H61.6546V2.14258H68.2549Z"
        fill={color || "white"}
      />
      <path
        d="M101.048 2.14258H74.4375V29.0002H101.048V18.4975L98.1144 15.5714L101.048 12.6453V2.14258ZM94.4476 23.2002H81.0901V18.8633H94.4476V23.2002ZM94.4476 12.2795H81.0901V7.78582H94.4476V12.2795Z"
        fill={color || "white"}
      />
      <path
        d="M292.872 11.3911V18.6019V21.9983H287.006V11.3911H281.401V21.9983H274.591V11.3911H259.819C259.138 11.4434 258.562 11.4956 257.933 11.6001C257.357 11.7046 256.781 11.9136 256.205 12.2272C255.628 12.5407 255.052 13.0632 254.476 13.6902C253.9 14.3172 253.271 15.2055 252.59 16.3028V11.3389H246.933V17.8704H246.985V21.9461H191.303V11.3911H174.121V17.9226V19.229C174.121 19.856 174.121 20.4308 174.121 21.0578C174.121 22.1028 174.121 23.0956 174.121 24.1407V27.5893H179.778V16.8776H185.645V27.5893H309.949V11.3911H292.872ZM269.038 21.9983H252.119C252.643 20.8488 253.219 19.9605 253.847 19.2812C254.476 18.6019 255.105 18.0794 255.785 17.7136C256.466 17.3479 257.095 17.1389 257.776 17.0344C258.457 16.9299 259.086 16.8776 259.714 16.9299H269.038V21.9983ZM304.344 21.9983H298.477V16.8776H304.344V21.9983Z"
        fill={color || "white"}
      />
      <path
        d="M287.057 2.45605H281.242V8.25605H287.057V2.45605Z"
        fill={color || "white"}
      />
      <path
        d="M189.889 2.45605H184.074V8.25605H189.889V2.45605Z"
        fill={color || "white"}
      />
      <path
        d="M181.924 2.45605H176.109V8.25605H181.924V2.45605Z"
        fill={color || "white"}
      />
      <path
        d="M154.736 2.45605H148.922V8.25605H154.736V2.45605Z"
        fill={color || "white"}
      />
      <path
        d="M146.83 2.45605H141.016V8.25605H146.83V2.45605Z"
        fill={color || "white"}
      />
      <path
        d="M161.547 21.4235V27.6416H135.355V11.3911H141.013V21.9983H155.889V14.9965C155.889 14.892 155.889 14.7875 155.889 14.683V11.3911H161.494C161.494 13.1154 161.494 14.5262 161.494 15.7281C161.494 16.8776 161.494 17.8704 161.494 18.6019C161.494 19.3857 161.494 19.9605 161.494 20.4308C161.547 20.8488 161.547 21.1623 161.547 21.4235Z"
        fill={color || "white"}
      />
      <path
        d="M119.012 2.14258H116.707V29.0002H119.012V2.14258Z"
        fill={color || "white"}
      />
    </svg>
  );
};

export default Logo;
